<template>
  <div :class="{ fullscreen: fullscreenQrScanner }" ref="wrapper" @fullscreenchange="onFullscreenChange">
    <qrcode-stream v-if="visible" @decode="decodeQr">
      <v-btn @click="onCancel" class="cancel-button">
        {{ $t('login.cancel') }}
      </v-btn>
      <v-btn v-if="!fullscreenQrScanner" @click="setFullScreen" class="fullscreen-button">{{ $t('login.fullScreen') }}</v-btn>
    </qrcode-stream>
  </div>
</template>

<script>
  import { QrcodeStream } from 'vue-qrcode-reader'
  import uk from '../../../langs/login/uk.json'
  import ru from '../../../langs/login/ru.json'
  import en from '../../../langs/login/en.json'
  export default {
    props: {
      visible: { type: Boolean, required: true },
      isFullScrenOnStart: { type: Boolean, required: false, default: true }
    },
    data: () => ({
      fullscreenQrScanner: false
    }),
    components: {
      'qrcode-stream': QrcodeStream
    },
    watch: {
      fullscreenQrScanner(enterFullscreen) {
        if (enterFullscreen) {
          this.requestFullscreen()
        } else {
          this.exitFullscreen()
        }
      },
      // Делать full-screen qr сканера при открытии модального окна
      visible(value) {
        if (value && this.isFullScrenOnStart) {
          this.requestFullscreen()
        }
      }
    },

    methods: {
      setFullScreen() {
        this.fullscreenQrScanner = true
      },
      // eslint-disable-next-line no-unused-vars
      onFullscreenChange(event) {
        // This becomes important when the user doesn't use the button to exit
        // fullscreen but hits ESC on desktop, pushes a physical back button on
        // mobile etc.

        this.fullscreenQrScanner = document.fullscreenElement !== null
      },
      decodeQr(code) {
        this.setQrScannerState(false)
        this.$emit('decode', code)
      },
      onCancel() {
        this.setQrScannerState(false)
        this.$emit('cancel')
      },
      setQrScannerState(state) {
        this.qrScannerVisible = state
        this.fullscreenQrScanner = state
      },
      requestFullscreen() {
        const elem = this.$refs.wrapper

        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen()
        }
      },
      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen()
        }
      }
    },
    i18n: {
      messages: {
        uk,
        en,
        ru
      }
    }
  }
</script>

<style scoped>
  .fullscreen {
    position: fixed;
    z-index: 1000;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }

  .fullscreen-button {
    background-color: white;
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 1rem;
  }
  .fullscreen-button img {
    width: 2rem;
  }

  .cancel-button {
    background-color: white;
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 1rem;
  }
  .cancel-button img {
    width: 2rem;
  }
</style>
